import './ListItem.css';

import { IonBadge, IonCard, IonCardContent, IonCol, IonIcon, IonLabel, IonRow, IonText } from '@ionic/react';
import { calendarOutline } from 'ionicons/icons';

interface Props {
    title: any,
    value?: any,
    valueText?: any,
    valueBadge?: boolean,
    dateTitle: string,
    date: string,
    color: string,
    footerIcon?: any,
    status?: string,
    link?: any
}

const ListItem: React.FC<Props> = (props) => {
    return <IonCard button={props.link !== undefined} routerLink={props.link!} routerDirection="forward" className={`list-item ${props.color}`}>
        <IonCardContent>
            <IonRow>
                <IonCol size={props.value !== undefined && props.status !== undefined ? "4" : "8"} className={props.value !== undefined && props.status !== undefined ? "detail" : "detail align-right"}>
                    <IonText><strong>{props.title}</strong></IonText>
                </IonCol>
                {props.value !== undefined ?
                    <IonCol size="4" className="detail">
                        <IonLabel>{props.valueText}</IonLabel>
                        {props.valueBadge !== undefined ?
                            <IonBadge>{Number(props.value).toPrice()}</IonBadge>
                            : <IonText>{Number(props.value).toPrice()}</IonText>}
                    </IonCol> : null}
                {props.status !== undefined ?
                    <IonCol size="4">
                        <div className="status">{props.status}</div>
                    </IonCol> : null}
            </IonRow>
        </IonCardContent>

        <div className="footer">
            <div className="ion-float-left ltr">{props.date}</div>
            <div className="ion-float-right"><IonIcon icon={props.footerIcon == undefined ? calendarOutline :props.footerIcon} /> {props.dateTitle}</div>
        </div>
    </IonCard >
}

export default ListItem